let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8pAMM")).then(() => parcelRequire('auMmF'));